/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2025-05-08 17:08:30
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-11-18 23:56:31
 * @FilePath: /mer_plat_admin/src/router/modules/collectivePurchase.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import Layout from '@/layout';
var collectivePurchaseRouter = {
  path: '/collectivePurchase',
  component: Layout,
  redirect: '/collectivePurchase/index',
  name: 'collectivePurchase',
  alwaysShow: true,
  meta: {
    title: '集采管理',
    icon: 's-custom'
  },
  children: [{
    path: 'procurement',
    component: function component() {
      return import('@/views/collectivePurchase/procurement');
    },
    name: 'procurement',
    meta: {
      title: '用户端集采管理',
      icon: ''
    },
    children: [{
      path: 'intent',
      name: 'procurementIntent',
      meta: {
        title: '集采留言管理',
        noCache: true
      },
      component: function component() {
        return import('@/views/collectivePurchase/procurement/intent.vue');
      }
    }, {
      path: 'list',
      name: 'procurementList',
      meta: {
        title: '集采流程管理',
        noCache: true
      },
      component: function component() {
        return import('@/views/collectivePurchase/procurement/list.vue');
      }
    }, {
      path: 'userList',
      name: 'procurementUser',
      meta: {
        title: '集采用户管理',
        noCache: true
      },
      component: function component() {
        return import('@/views/collectivePurchase/procurement/userList.vue');
      }
    }, {
      path: 'department',
      name: 'procurementDepartment',
      meta: {
        title: '集采部门管理',
        noCache: true
      },
      component: function component() {
        return import('@/views/collectivePurchase/procurement/department.vue');
      }
    }, {
      path: 'purchaseList',
      name: 'procurementPurchaseList',
      meta: {
        title: '集采采购单管理',
        noCache: true
      },
      component: function component() {
        return import('@/views/collectivePurchase/procurement/purchaseList.vue');
      }
    }, {
      path: 'addition/:id?/:copy?',
      name: 'addition',
      meta: {
        title: '新增集采流程',
        noCache: true,
        activeMenu: "/collectivePurchase/procurement/list"
      },
      component: function component() {
        return import('@/views/collectivePurchase/procurement/addition.vue');
      }
    }, {
      path: 'view/:id',
      name: 'view',
      meta: {
        title: '查看集采流程',
        noCache: true,
        activeMenu: "/collectivePurchase/procurement/list",
        readonly: true
      },
      component: function component() {
        return import('@/views/collectivePurchase/procurement/addition.vue');
      }
    }]
  }, {
    path: 'address',
    component: function component() {
      return import('@/views/collectivePurchase/address/index');
    },
    name: 'addressdIndex',
    meta: {
      title: '地址管理'
    }
  }, {
    path: 'flowChart',
    component: function component() {
      return import('@/views/collectivePurchase/flowChart/index');
    },
    name: 'flowChartIndex',
    meta: {
      title: '审核流程管理'
    }
  }, {
    path: 'productLibrary',
    component: function component() {
      return import('@/views/collectivePurchase/productLibrary/index');
    },
    name: 'productLibraryIndex',
    meta: {
      title: '产品库'
    }
  }, {
    path: 'listIntentions',
    component: function component() {
      return import('@/views/collectivePurchase/listIntentions/index');
    },
    name: 'listIntentionsIndex',
    meta: {
      title: '意向清单'
    }
  }, {
    path: 'purchaseList',
    component: function component() {
      return import('@/views/collectivePurchase/purchaseList/index');
    },
    name: 'purchaseListIndex',
    meta: {
      title: '采购单列表'
    }
  }]
};
export default collectivePurchaseRouter;